/* eslint-disable */

import ResourcePattern from '@/services/resource-patters';

export default ResourcePattern('AccessProvider', 'companies', ({ Api, servicename, resource }) => ({
  actions: {
    async get(_, { params }) {
      const { data, headers } = await Api.get(servicename, resource, { params });
      return {
        data,
        total: Number(headers['x-total-count']),
      };
    },
    async count(_, { params }) {
      const { data } = await Api.get(servicename, `${resource}/count`, { params });
      return data;
    },
    async find(_, { id }) {
      const { data } = await Api.get(servicename, `${resource}/${id}`);
      return data;
    },
    async delete(_, { id }) {
      await Api.delete(servicename, `${resource}/${id}`);
    },
    async create(_, { dataForm }) {
      const { data } = await Api.post(servicename, `${resource}`, dataForm);
      return data;
    },
    async update(_, { id, dataForm }) {
      const { data } = await Api.patch(servicename, `${resource}/${id}`, dataForm);
      return data;
    },
  },
}));
/* eslint-enable */
